import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Snackbar } from '@mui/material';
import { AppContext } from '../../../store/AppStore';
import { App_sesion_token_key, AxiosInstance, FormatPrice } from '../../../utils/constants';
import { isSubastaLiveEnabled } from '../flags';
import { useAuctionSocket } from '../hooks/useAuctionSocket';

const MAX_ROOMS = 20;

export const BuyerLiveShell = () => {
  const enabled = isSubastaLiveEnabled();
  const navigate = useNavigate();
  const location = useLocation();
  const { store: { profile } } = useContext(AppContext);
  const [rooms, setRooms] = useState([]);
  const [toast, setToast] = useState(null);
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem(App_sesion_token_key) : null;
  const inSala = location.pathname.includes('/subastas/sala/');

  useEffect(() => {
    if (!enabled || !profile?.cod) {
      return;
    }
    AxiosInstance.post('subastas/listar-maestro-subasta', {
      rows_per_page: MAX_ROOMS,
      page_number: 1,
    }).then(({ data }) => {
      const list = (data?.value?.data || []).filter((item) => item.ind_estado === 'PUBLICADA');
      const next = [`subasta:user:${profile.cod}`];
      list.slice(0, MAX_ROOMS).forEach((item) => next.push(`subasta:${item.cod}`));
      setRooms(next);
    }).catch(() => {
      setRooms([`subasta:user:${profile.cod}`]);
    });
  }, [enabled, profile?.cod]);

  const onEvent = useCallback((eventName, payload) => {
    if (inSala) {
      return;
    }
    if (eventName !== 'auction.bid_created' && eventName !== 'auction.price_updated') {
      return;
    }
    if (!payload?.cod_subasta) {
      return;
    }
    setToast({
      message: `Nueva puja en subasta N° ${payload.cod_subasta} · $ ${FormatPrice(payload.precio_vigente)}`,
      cod: payload.cod_subasta,
    });
  }, [inSala]);

  const extraRooms = useMemo(() => rooms, [rooms.join('|')]);

  useAuctionSocket({
    token,
    extraRooms,
    enabled: enabled && extraRooms.length > 0,
    onEvent,
  });

  if (!enabled) {
    return null;
  }

  return (
    <Snackbar
      open={!!toast}
      autoHideDuration={4000}
      onClose={() => setToast(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {toast && (
        <Alert
          severity="info"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                navigate(`/plataforma/subastas/sala/${toast.cod}`);
                setToast(null);
              }}
            >
              Abrir sala
            </Button>
          }
          onClose={() => setToast(null)}
        >
          {toast.message}
        </Alert>
      )}
    </Snackbar>
  );
};
